import { render, staticRenderFns } from "./NoticeBase.vue?vue&type=template&id=6f09ef21&"
import script from "./NoticeBase.vue?vue&type=script&lang=js&"
export * from "./NoticeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports